import React, { Component } from 'react';
import { LINKS } from 'src/constants';
// import cx from 'classnames';
import styles from './_mobileContactUs.module.scss';

export default class MobileContactUs extends Component {
  render() {
    const { contactUsData } = this.props;
    return (
      <div className={styles['mobile-contact-us']}>
        <div className={styles['title']}>{contactUsData?.title}</div>
        <div className={styles['desc-box']}>
          <div className={styles['desc']}>
            <a href={LINKS.SAVVY_WHATSAPP} target="_blank" rel="noreferrer">
              <div className={styles['number']}>
                <img src="/images/phone.svg" alt="phone" />
                +91 {contactUsData?.number}
              </div>
            </a>
            <a href={`mailto:${LINKS.EMAIL}`} target="_blank" rel="noreferrer">
              <div className={styles['email']}>
                <img src="/images/email.svg" alt="email" />
                {contactUsData?.email}
              </div>
            </a>
          </div>
        </div>
      </div>
    );
  }
}
